import { jsonTryParse } from '@ztechapps/common.utils'

/**
 * True when an AI-SDK error carries the `credits.exhausted` payload. The chat
 * route answers HTTP 422 with a JSON body shaped `{ type: 'credits.exhausted', error }`
 * and the Vercel AI SDK surfaces that body as `error.message`, so we parse it
 * as JSON. Anything else (plain text, another JSON body, the 429 rate-limit
 * body, no error) is not an exhausted-credits notice.
 */
export const isCreditsExhausted = (error: Error | undefined): boolean => {
  if (!error?.message) return false
  return jsonTryParse(error.message)?.type === 'credits.exhausted'
}
